import { OperationType, SpacePlanPaymentInfo } from '../../../../types';
import { PlanPaymentFormProps } from '../PlanPaymentSection/Providers';
import { PlanTemplateType } from '../types';

import {
  determineMaxCcu,
  determineOnetimePeriod,
  determinePlanTemplateType,
  determinePlanType,
  determineSubscriptionPeriod,
} from './planPaymentUtils';

/**
 * 서버에서 받아온 플랜 정보와 쿼리 매개변수를 기반으로 PlanPaymentInfoProviderProps를 생성합니다.
 * 결제페이지 진입 시에 결제페이지의 초기 상태를 설정하는 데 사용됩니다.
 * 초기 상태를 설정하는 대전제
 *   - 1. query params로 전달된 값들로 초기 상태를 설정 (!IMPORTANT)
 *   - 2. query가 없는 경우, 해당값은 현재 스페이스에 설정된 Plan의 해당 값으로 설정
 *   - 3. 위 두 가지에 모두 포함되지 않는 경우(query, planPaymentInfo 모두 없는 경우) 기본값으로 설정
 *     - 기본값: planType: 'pro', maxCcu: 10, planTemplateType: '1', subscriptionPeriod: '30', onetimePeriod: '1M'
 * @param query
 * @param planPaymentInfo
 */
export const createInitialProviderProps = (
  query: Record<string, any>,
  planPaymentInfo: SpacePlanPaymentInfo | undefined,
): PlanPaymentFormProps => {
  const queryPlanType = (query.planType || '').toString();
  const planPaymentInfoPlanType =
    planPaymentInfo?.spacePlan?.status === 'ACTIVE'
      ? planPaymentInfo?.spacePlan?.planType
      : undefined;
  const planPaymentInfoMaxCcu =
    planPaymentInfo?.spacePlan?.status === 'ACTIVE'
      ? planPaymentInfo?.spacePlan?.maxCcu
      : undefined;
  const planPlanTemplateType =
    planPaymentInfo?.spacePlan?.status === 'ACTIVE' &&
    planPaymentInfo?.spacePlan?.operationType === OperationType.일시납
      ? PlanTemplateType.PRODUCT_ONETIME
      : PlanTemplateType.PRODUCT_SUBSCRIPTION;
  const planOnetimePeriod =
    planPaymentInfo?.spacePlan?.status === 'ACTIVE'
      ? planPaymentInfo?.subscription?.onetimePeriod
      : undefined;
  const planSubscriptionPeriod =
    planPaymentInfo?.spacePlan?.status === 'ACTIVE'
      ? planPaymentInfo?.subscription?.subscriptionPeriod
      : undefined;

  const planType = determinePlanType(queryPlanType, planPaymentInfoPlanType);
  const maxCcu = determineMaxCcu(planType, planPaymentInfoMaxCcu);
  const planTemplateType = determinePlanTemplateType(
    (query.planTemplateType || '').toString(),
    planPlanTemplateType,
  );
  const onetimePeriod = determineOnetimePeriod(
    (query.onetimePeriod || '').toString(),
    planOnetimePeriod,
  );
  const subscriptionPeriod = determineSubscriptionPeriod(
    (query.subscriptionPeriod || '').toString(),
    planSubscriptionPeriod,
  );

  return {
    planType,
    maxCcu,
    planTemplateType,
    onetimePeriod,
    subscriptionPeriod,
    planPaymentInfo,
  };
};
